import React from 'react';
import InnerPageBanner from '../components/InnerPageBanner';
import { Box, Container, Typography, Grid } from '@mui/material'; // Use standard Grid
import gallery from "../assets/Gallery.jpeg";
import gallery1 from "../assets/Gallery1.jpeg";
import gallery2 from "../assets/Gallery2.jpeg";
import gallery3 from "../assets/Gallery3.jpeg";
const Gallery = () => {
    return (
        <Box>
            <InnerPageBanner title="Gallery" />

            {/* Main Content Section */}
            <Container sx={{ py: 5, }}>
                {/* First Section: Image and Description */}
                <Box sx={{ py: 8, backgroundColor: "#f5f5f5" }}>
                    <Grid container spacing={6} alignItems="center" justifyContent="center" sx={{ px: 4 }}>
                        {/* LEFT SIDE IMAGE */}
                        <Grid size={{ xs: 12, md: 6 }}>
                            <Box
                                component="img"
                                src={gallery}
                                alt="Gallery"
                                sx={{
                                    width: "100%",
                                    borderRadius: 3,
                                    boxShadow: 3,
                                }}
                            />
                        </Grid>

                        {/* RIGHT SIDE CONTENT */}
                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography variant="h3" sx={{ fontWeight: 700, mb: 2 }}>
                                Gallery
                            </Typography>

                            <Box
                                sx={{
                                    width: "80px",
                                    height: "4px",
                                    backgroundColor: "#20c997",
                                    mb: 3,
                                }}
                            />

                            <Typography variant="h6" sx={{ color: "gray", mb: 1 }}>
                                Available Color
                            </Typography>

                            <Typography variant="body1" sx={{ fontSize: '1.1rem' }}>
                                Grey (White)
                            </Typography>
                        </Grid>
                    </Grid>
                </Box>

                {/* ---------------- Gallery BOX SECTION ---------------- */}
                <Box sx={{ py: 10 }}>
                    {/* MAIN HEADING */}
                    <Typography
                        variant="h4"
                        sx={{
                            fontWeight: 700,
                            mb: 6
                        }}
                    >
                        Our Gallery Models
                    </Typography>

                    {/* ITEM 1 - Garden Gallery */}
                    <Box sx={{ mb: 8 }}>
                        <Typography
                            variant="h5"
                            sx={{
                                fontWeight: 600,
                                mb: 3,
                                color: '#333'
                            }}
                        >
                            • Garden Gallery
                        </Typography>

                        <Box
                            component="img"
                            src={gallery1}
                            alt="Garden Gallery"
                            sx={{
                                width: "100%",
                                maxHeight: 500,
                                objectFit: "cover",
                                borderRadius: 3,
                                boxShadow: 3,
                            }}
                        />
                    </Box>

                    {/* ITEM 2 - Park Gallery */}
                    <Box sx={{ mb: 8 }}>
                        <Typography
                            variant="h5"
                            sx={{
                                fontWeight: 600,
                                mb: 3,
                                color: '#333'
                            }}
                        >
                            • Park Gallery
                        </Typography>

                        <Box
                            component="img"
                            src={gallery2}
                            alt="Park Gallery"
                            sx={{
                                width: "100%",
                                maxHeight: 500,
                                objectFit: "cover",
                                borderRadius: 3,
                                boxShadow: 3,
                            }}
                        />
                    </Box>

                    {/* ITEM 3 - Concrete Gallery */}
                    <Box>
                        <Typography
                            variant="h5"
                            sx={{
                                fontWeight: 600,
                                mb: 3,
                                color: '#333'
                            }}
                        >
                            • Concrete Gallery
                        </Typography>

                        <Box
                            component="img"
                            src={gallery3}
                            alt="Concrete Gallery"
                            sx={{
                                width: "100%",
                                maxHeight: 500,
                                objectFit: "cover",
                                borderRadius: 3,
                                boxShadow: 3,
                            }}
                        />
                    </Box>
                </Box>
            </Container>
        </Box>
    );
};

export default Gallery;